import { appApiSlice } from 'src/api/app-ApiSlice';
import { GetProjectTreeProject } from 'src/model/api/get-project-tree-project.model';
import { GetProjectTreeProjectChildNode } from 'src/model/api/get-project-tree-project-childnode.model';
import { TAG_PROJECT_TREE } from 'src/api/api-tags';

export const getProjectTreeApiSlice = appApiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProjectTree: builder.query<GetProjectTreeProject[], void>({
      query: () => 'v1/get-project-tree',
      providesTags: [{ type: TAG_PROJECT_TREE }],
    }),
    getProjectTreeProject: builder.query<GetProjectTreeProjectChildNode[], number>({
      query: (projectId) => `v1/get-project-tree/get-project?project_id=${projectId}`,
      providesTags: [{ type: TAG_PROJECT_TREE }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetProjectTreeQuery,
  useGetProjectTreeProjectQuery,
} = getProjectTreeApiSlice;
